import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useAccessToken, useQueryParam, useViewport } from '@chilecompra/react-kit'
import { Card, Breadcrumb, Breadcrumbs, Button, Typography } from '@chilecompra/react-kit/components'

import routes from '../../config/settings/routes'
import CustomIframe from '../../components/Custom/Iframe'
import ProtectByFeatures from '../../components/Security/ProtectByFeatures'
import { Grid, ImgOnboarding01, Root, Row } from './SellerQuotePublishedSuccessfully.styles'

/**
 * The SellerQuotePublishedSuccessfully's container.
 */
const SellerQuotePublishedSuccessfully = () => {
  const accessToken = useAccessToken()
  const quoteCode = useQueryParam('quote')
  const navigate = useNavigate()

  const {
    size: { isDownToMedium }
  } = useViewport()

  const {
    basicInfo: { dateClose }
  } = useSelector(state => state.quoteBasicInformation)

  const handleGoBackSearchQuote = () => navigate(routes.search)
  const handleGoSummary = () => navigate(routes.quoteSummary.replace(/:quoteId/, quoteCode))

  return (
    <Root>
      <Breadcrumbs onClick={handleGoBackSearchQuote}>
        <Breadcrumb>Escritorio</Breadcrumb>
        <Breadcrumb>Compra ágil</Breadcrumb>
      </Breadcrumbs>

      <Grid container justifyContent="center">
        <Card color="blank" enableBorder margin="24px 0 0" width={isDownToMedium ? '100%' : '900px'}>
          <Row>
            <ImgOnboarding01 src="/assets/images/onboarding-01.svg" />

            <Typography fontWeight="bold" margin="0 0 8px" variant="h4">
              Cotización enviada correctamente
            </Typography>

            <Typography variant="body2">Puedes revisar el estado del proceso desde la opción Compra Ágil</Typography>

            <Grid container justifyContent="center" margin="16px 0 0">
              <Card color="default" width="600px">
                <Typography color="black2" fontSize="16px" fontWeight="bold" margin="0 0 8px" variant="caption">
                  ID: {quoteCode}
                </Typography>

                <Typography color="black2" variant="subtitle">
                  El proceso cerrará el {dateClose}
                </Typography>

                <Typography color="black2" variant="body2">
                  Los criterios de selección en una Compra Ágil no se basan exclusivamente en <br />
                  el precio más bajo; también pueden considerar aspectos como requisitos técnicos, plazos de entrega,
                  entre otros, y son responsabilidad de cada <br /> organismo comprador.
                </Typography>
              </Card>
            </Grid>
          </Row>

          <Row>
            <Button color="primary" margin="32px 0 8px" onClick={handleGoSummary}>
              Ver cotización enviada
            </Button>
          </Row>

          <Row>
            <Button onClick={handleGoBackSearchQuote} variant="text">
              Volver a Compra Ágil
            </Button>
          </Row>
        </Card>

        <ProtectByFeatures rule={features => features['enable.survey']}>
          <CustomIframe accessToken={accessToken} quoteCode={quoteCode} />
        </ProtectByFeatures>
      </Grid>
    </Root>
  )
}

export default SellerQuotePublishedSuccessfully
